import { React, useState } from "react";
import PropTypes from "prop-types";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { contentProps} from "../utils";
import { Backdrop, CircularProgress } from "@mui/material";
import { BsPlusLg } from "react-icons/bs";
import { HiMinus } from "react-icons/hi";

function SingleBook({
	index,
	singleChapterData,
	createChapterTemplate,
	chapters,
	setChapters,
	// type,
}) {
	// eslint-disable-next-line no-unused-vars
	const [videoSrc, setVideoSrc] = useState("");
	const [loading, setLoading] = useState(false);
	const [thumbnailUrl, setThumbnailUrl] = useState("");
    const [isThumbnailSaved, setIsThumbnailSaved] = useState(false)
	//upload video
	const onChange = (info, section) => {
		if (info.file.status !== "done" && section === "book") {
			saveContentToParse(info); //set actual upload file to parse
		}
        //onchange method is being used to upload book file and thumbnail, hence there is a check
         else {
			if (info.file.status !== "done") {
				const url = URL.createObjectURL(info?.file);
				setThumbnailUrl(url);
				saveContentToParse(info, "thumbnail"); //set actual upload file to parse
			}
		}
	};

	//stop ant design default behaviour of uploading to a server
	const beforeUpload = (file, section) => {
		if (section === "book") {
			return false;
		} else {
			const url = URL.createObjectURL(file);
			setThumbnailUrl(url);
			return false;
		}
	};



	//handle change in form in each chapter and set the value to the chapter state
	const handleInputChange = (e, id) => {
		let chapterCopy = [...chapters];
		chapterCopy = chapterCopy.map((data, index) => {
			if (data.id === id) {
				return {
					...data,
					[e.target.name]: e.target.value,
					chapter: index + 1,
				};
			} else {
				return data;
			}
		});
		setChapters(chapterCopy);
	};

	//save video/audio/thumbnail url to the particular chapter using chapter's id
	const saveLink = (url, currentId, fileType) => {
        //if filetype is passed, we are saving thumbnail url to state
		if (fileType) {
			let chapterCopy = [...chapters];
			chapterCopy = chapterCopy.map((data) => {
				if (data.id === currentId) {
					return {
						...data,
						coverPhoto: url,
					};
				} else {
					return data;
				}
			});
			setChapters(chapterCopy);
		}
        //save document url to state
         else {
			let chapterCopy = [...chapters];
			chapterCopy = chapterCopy.map((data) => {
				if (data.id === currentId) {
					return {
						...data,
						link: url,
					};
				} else {
					return data;
				}
			});
			setChapters(chapterCopy);
		}
	};



	//host video url on parse
	const saveContentToParse = async (data, fileType) => {
		setLoading(true);
		try {
			const sanitizedFileName = data?.file.name.replace(/[^\w.-]+/g, "");
			const ContentFile = new Parse.File(sanitizedFileName, data?.file);
			await ContentFile.save();
			if (fileType) {
				console.log("save thumbnail to parse url");
				saveLink(ContentFile?._url, singleChapterData?.id, fileType);
				toast.success("Thumbnail successfully saved");
                setIsThumbnailSaved(true)
			} else {
				saveLink(ContentFile?._url, singleChapterData?.id); //save content  url to its state data
                toast.success("file successfully saved");
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.log(error);
			toast.error("unable to save  file, please try again later");
			console.error("Error saving item:", error);
		}
	};

	const removeChapter = () => {
		let chapterCopy = [...chapters];
		chapterCopy = chapterCopy.filter(
			(data) => data.id !== singleChapterData?.id
		);
		setChapters(chapterCopy);
	};

	
	return (
		<div className='mt-4'>
			<header className='flex space-between'>
				<h2 style={{ fontWeight: "bold", fontSize: "1rem" }}>
					CHAPTER {index + 1}
				</h2>

				<div className='flex flex-col gap-2'>
					<div className='flex gap-2 pointer' onClick={createChapterTemplate}>
						<BsPlusLg size={18} /> Add more chapters
					</div>
					{chapters.length > 1 && (
						<div onClick={removeChapter} className='flex gap-2 pointer'>
							<HiMinus size={18} /> Remove chapter
						</div>
					)}
				</div>
			</header>
			<div className='form-group'>
				<label>TITLE</label>
				<input
					style={{ cursor: "text" }}
					name='name'
					className='w-full border padding'
					onChange={(e) => handleInputChange(e, singleChapterData?.id)}
					value={singleChapterData?.name}
					required={true}
				/>
			</div>

			<div className='form-group'>
				<label>DESCRIPTION</label>
				<textarea
					style={{ cursor: "text" }}
					name='description'
					className='w-full border padding'
					onChange={(e) => handleInputChange(e, singleChapterData?.id)}
					value={singleChapterData?.description}
					required={true}
				/>
			</div>

			<div className='form-group'>
				<label>UPLOAD CONTENT DOCUMENT</label>
				<Upload
					onChange={(e) => onChange(e, "book")}
					{...contentProps}
					beforeUpload={(e) => beforeUpload(e, "book")}
					accept='.pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				>
					<Button
						style={{ color: "#959595", fontSize: "1rem" }}
						icon={<UploadOutlined style={{ fontSize: "1.2rem" }} />}
					>
						Click to upload
					</Button>
				</Upload>
			</div>

			<div className='form-group'>
				<label className='mt-4'>ADD THUMBNAIL</label>
				<Upload
					onChange={(e) => onChange(e, "thumbnail")}
					{...contentProps}
					beforeUpload={(e) => beforeUpload(e, "thumbnail")}
					accept='image/*'
				>
					<Button
						style={{ color: "#959595", fontSize: "1rem" }}
						icon={<UploadOutlined style={{ fontSize: "1.2rem" }} />}
					>
						Click to upload
					</Button>
				</Upload>
			</div>
			{isThumbnailSaved ? (
				<img
					className='mt-6'
					style={{ objectFit: "contain", height: "20rem" }}
					alt='thumbnail'
					src={thumbnailUrl}
				/>
			) : null}

			{/* <div className='form-group'>
            <label>WRITE CONTENT</label>
				<textarea
					style={{ cursor: "text" }}
					name='content'
					className='w-full border padding'
					onChange={(e) => handleInputChange(e, singleChapterData?.id)}
					value={singleChapterData?.content}
					required={true}
				/>
			</div> */}

        

			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</div>
	);
}

SingleBook.propTypes = {
	index: PropTypes.number,
	singleChapterData: PropTypes.object,
	chapters: PropTypes.array,
	setChapters: PropTypes.func,
	createChapterTemplate: PropTypes.func,
	type: PropTypes.string,
};

export default SingleBook;
